import React from "react";
import styled from "styled-components";

export default styled.div`
    width: 50%;
    float: left;
    min-height: 1px;
    margin-bottom: 20px;
    clear: both;
    
    &.plans {
        padding-right: 25px;
        width: calc(50% + 45px);
        margin-left: -10px;
    }
`;